import { upperFirst } from 'lodash'

import { components, proxy } from '@/utils'

import settingsFields from '@/components/services/settings/fields'
import { _inputFilter, _outputFilter } from '@/components/services/settings/smpp/ipWhitelist/mixins'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy({ type: 'array' }) ],

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return h(
        settingsFields(
          options,
          {
            type: 'array',
            _inputFilter,
            _outputFilter
          }
        ),
        {
          props: {
            value: this.proxy,
            items: [ { component: components.textarea } ],
            dialog: true
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
